import { useState, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Loader, TitleSection } from "../common";
import { ASSETS_URL, BlogModel } from "../../service";
import { Fade } from "react-awesome-reveal";
import { FaChevronRight } from "react-icons/fa";
import { MdHomeFilled } from "react-icons/md";

type SingleBlogProps = {
  id: string;
};

export default function SingleBlogScreen(props: SingleBlogProps) {
  const [blog, setBlog] = useState<BlogModel>(new BlogModel("", "", "", ""));
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [breadCrumbs, setBreadCrumbs] = useState([
    { title: <MdHomeFilled />, link: "/" },
    { title: "Blogs", link: "/blogs" },
  ]);

  useEffect(() => {
    const getBlog = async () => {
      try {
        let response = await BlogModel.getBlog(props.id);
        let result = response.data.data;
        let blogData = new BlogModel(
          result._id,
          result.title,
          result.description,
          result.image
        );
        setBlog(blogData);
        setBreadCrumbs([...breadCrumbs, { title: result.title, link: "#" }]);
      } catch (error) {
        console.log(error);
        navigate("/");
      } finally {
        setIsLoading(false);
      }
    };
    getBlog();
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="container mx-auto px-6 py-16">
            <Fade triggerOnce>
              <div className="flex flex-wrap items-center gap-1 mb-5 pt-14">
                {breadCrumbs &&
                  breadCrumbs.map((item, i) => {
                    if (i < breadCrumbs.length - 1) {
                      return (
                        <>
                          <NavLink
                            key={i}
                            to={item.link}
                            className={i === 0 ? "text-lg" : "text-sm"}
                          >
                            {item.title}
                          </NavLink>
                          <FaChevronRight fontSize="12px" />
                        </>
                      );
                    } else {
                      return (
                        <NavLink key={i} to={item.link} className="text-sm">
                          {item.title}
                        </NavLink>
                      );
                    }
                  })}
              </div>
              <img
                src={
                  blog.image == "avatar.jpg"
                    ? "/images/residential-bg.jpg"
                    : ASSETS_URL + blog.image
                }
                className="w-full h-60 md:h-96 object-cover object-center rounded-xl mb-5"
              />
              <p className="text-3xl font-bold lg:text-4xl mb-7">
                {blog.title}
              </p>
              <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: blog?.description }}
              />
            </Fade>
          </div>
        </>
      )}
    </>
  );
}
